import { Component, ViewChild, OnInit, Input } from '@angular/core';
import { CountdownComponent } from '../countdown.component/countdown.component';
import { LotteryService } from 'src/app/services';

@Component({
    selector: 'app-countdown-ticket-win-history',
    templateUrl: 'countdown-ticket-win-history.component.html',
    styleUrls: ['./countdown-ticket-win-history.component.scss']
})
export class CountdownTicketWinHistoryComponent implements OnInit
{
    @ViewChild('countdown', { static: true }) public countDown: CountdownComponent;

    public t: Date;
    public isWithinRegularRange: boolean;
    public isWithinDrawPeriodRange: boolean;

    private lotteryService: LotteryService;

    public constructor(lotteryService: LotteryService)
    {
        this.lotteryService = lotteryService;
    }

    public ngOnInit(): void
    {
        this.determineSalesPeriod();
        this.setT();
    }

    private setT(): void
    {
        if(!this.isWithinDrawPeriodRange)
        {
            this.lotteryService.getSaleStop().subscribe((result) => {
                const seconds = parseInt(result.Seconds, 10) || 0;
                const minutes = parseInt(result.Minutes, 10) || 0;
                const hours = parseInt(result.Hours, 10) || 0;
                const days = parseInt(result.Days, 10) || 0;
    
                const x = new Date();
                x.setDate(x.getDate() + days);
                x.setHours(x.getHours() + hours);
                x.setMinutes(x.getMinutes() + minutes);
                x.setSeconds(x.getSeconds() + seconds);
    
                this.t = x;
            });
        }
        else
        {
            const now = new Date();
            const currentDay = now.getDate();

            // Check if today is past the 15th of the current month
            if (currentDay > 15) {
                // Move to the 15th of the next month
                const nextMonth = new Date(now.getFullYear(), now.getMonth() + 1, 15, 15, 0, 0);
                this.t = nextMonth;
            } else {
                // Return the 15th of the current month
                const currentMonth = new Date(now.getFullYear(), now.getMonth(), 15, 15, 0, 0);
                this.t = currentMonth;
            }
        }
    }

    private determineSalesPeriod(): void
    {
        const today = new Date();
        const currentYear = today.getFullYear();
        const currentMonth = today.getMonth();
        const currentDate = today.getDate();
        const currentHour = today.getHours(); // Get the current hour (0-23)

        // Check if the date is between the 20th of the current month and the 15th of the next month
        if (currentDate >= 20) {
            // If today is the 20th or later, the range is this month (20th) to next month (15th)
            const startOfRange = new Date(currentYear, currentMonth, 20);
            const endOfRange = new Date(currentYear, currentMonth + 1, 15);
            this.isWithinRegularRange = today >= startOfRange && today <= endOfRange;
        } else {
            // If today is before the 20th, the range is the previous month (20th) to this month (15th)
            const startOfRange = new Date(currentYear, currentMonth - 1, 20);
            const endOfRange = new Date(currentYear, currentMonth, 15);
            this.isWithinRegularRange = today >= startOfRange && today <= endOfRange;
        }

        // Check if today is the 15th and the hour is between 10 and 15
        this.isWithinDrawPeriodRange = (currentDate === 15) && (currentHour >= 10 && currentHour < 15);
    }
}
